var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},_vm._l((_vm.article.components),function(component,index){return _c('ArticleComponent',{key:index,attrs:{"data":component.data,"component":component}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }